import { useEffect, RefObject } from "react"

/**
 * Hook that calls the callback when a click occurs outside the referenced element.
 *
 * @param ref - React ref object pointing to the element to detect outside clicks for.
 * @param callback - Function to call when an outside click is detected.
 */
export function useOutsideAlerter<T extends HTMLElement>(
  ref: RefObject<T | null>,
  callback: () => void
) {
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref, callback])
}